import { render, staticRenderFns } from "./ManageExpiryDate.vue?vue&type=template&id=c6ea7de8"
import script from "./ManageExpiryDate.vue?vue&type=script&lang=js"
export * from "./ManageExpiryDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports